import React, { useContext, useState, useEffect } from 'react'
import { apiGet, apiPut } from '../../utils/apiFetch'
import pathObj from '../../utils/pathObj'
import { useTranslation } from 'react-i18next'
import AuthContext from 'context/AuthContext'
import SettingsCurrencyComponent from './SettingsCurrencyComponent'

const SettingsCurrency = () => {
  const { logoutUser, updatePageName } = useContext(AuthContext)
  const { t } = useTranslation()
  const [settingData, setSettingData] = useState([])

  const getSettings = async () => {
    try {
      const res = await apiGet(pathObj.getCurrencySettings)
      if (res) {
        setSettingData(res?.data?.results)
      }
    } catch (error) {
      console.log('error:', error)

      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser()
      }
    }
  }

  useEffect(() => {
    getSettings()
    updatePageName(t('NAV_CURRENCY_SETTINGS'))
  }, [])


  return (
    <>
      <div id="accordion" className='p-4'>
        {settingData.map((element, idx) => (
          <div className='accordion-item mb-5' style={{background: '#6536ff', padding: '1rem', borderRadius: "1rem"}} key={"currencySetting" + idx}>
            <h2 className="accordion-header" id={"heading" + idx}>
              <button className="accordion-button" style={{color:'white', fontWeight: 'bold', paddingInline: '2rem'}} type="button">
                {element.currency_code} - {element.currency_name}
              </button>
            </h2>
            <div id={"collapse" + idx}>
              <div className="accordion-body">
                  <SettingsCurrencyComponent settingData={element} />
              </div>
            </div>
          </div>
        ))
        }
      </div>
    </>
  )
}

export default SettingsCurrency